export default "__VITE_ASSET__CXEFuC3I__"